import { SortAscendingIcon as PhosphorSortAscendingIcon } from "@phosphor-icons/react/dist/ssr/SortAscending";

import { createAppIcon } from "@/components/createAppIcon";

export const SortAlphabeticallyIcon = /* @__PURE__ */ createAppIcon(PhosphorSortAscendingIcon);
